import React from 'react';
import { ButtonStyled } from './ButtonStyled';

const Button = ({onClick, onHover, type="submit", children}) => {
    return (
        <ButtonStyled type={type} onClick={onClick} onHover={onHover} className='gtm-cta'>
            {children}
        </ButtonStyled>
    );
};

export default Button;